module.exports = __webpack_public_path__ + "icon_cactus.41e9c1f5dfcad7470108c5a9389944b3.svg";